import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSavedQuiz } from "@/lib/api";
import { PaddleCard } from "@/components/PaddleCard";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";

export default function Share({ addToCart }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await getSavedQuiz(id);
        setData(res);
      } catch (e) {
        toast.error("Couldn't load this shared result");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return <div className="cd-container" data-testid="share-loading"><div className="cd-skel" style={{ height: 200 }} /></div>;
  }
  if (!data) {
    return (
      <div className="cd-container" data-testid="share-not-found">
        <div className="cd-card" style={{ padding: 24, textAlign: "center" }}>
          <h2 className="cd-h2">Shared result not found</h2>
          <button className="cd-btn-primary" style={{ marginTop: 12 }} onClick={() => navigate("/")}>
            Take the quiz
          </button>
        </div>
      </div>
    );
  }

  const results = data.top_paddles || [];

  return (
    <div className="cd-container-wide cd-court-bg cd-fade-in" data-testid="share-page">
      <span className="cd-chip cd-chip-accent">Shared with you</span>
      <h1 className="cd-h1" style={{ margin: "12px 0 6px" }}>Someone shared their paddle picks.</h1>
      <p className="cd-sub" style={{ marginBottom: 20 }}>Check them out — or take the quiz for your own personalized matches.</p>

      <div className="cd-results-grid">
        {results.map((p, idx) => (
          <PaddleCard
            key={p.product_id}
            paddle={p}
            isTop={idx === 0}
            compareActive={false}
            compareSelected={false}
            onToggleCompare={() => {}}
            onAdd={(pp, v) => {
              if (!v) return;
              addToCart({
                product_id: pp.product_id,
                variant_id: v.variant_id,
                variant_title: v.title,
                title: pp.title,
                price: v.price || pp.price,
                image: pp.image,
              });
              toast.success(`${pp.title} added`);
            }}
          />
        ))}
      </div>

      <div style={{ marginTop: 24, textAlign: "center" }}>
        <button className="cd-btn-primary" onClick={() => navigate("/quiz")} data-testid="share-take-quiz-btn">
          <RotateCcw size={16} /> Take the quiz yourself
        </button>
      </div>
    </div>
  );
}
